declare global {
  interface Window {
    dataLayer: GtagEventData[]
    gtag: (...args: any[]) => void
  }
}

export interface GtagEventData {
  event: string
  [key: string]: any
}

export const gtag = (...args: any[]): void => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args)
  }
}
